"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function decorateControlMetadata(obj) {
    return function (target) {
        Reflect.defineMetadata('dynamic:module', obj, target);
    };
}
exports.decorateControlMetadata = decorateControlMetadata;
exports.ControlMetadata = decorateControlMetadata;
//# sourceMappingURL=meta-interfaces.js.map